module.exports = __webpack_public_path__ + "assets/icon_check.4a31ea11.svg";